import AdminPage from './AdminPage';
import ProjectPanel from './ProjectPanel';
import UserPanel from './UserPanel';
export default AdminPage;
export { ProjectPanel, UserPanel };
